import axios from 'axios';
import { WorkItemActionTypes } from './';

const endpoint = `${process.env.REACT_APP_ERP_API_HOST}/request/item/assignees`;

export function findWorkItemsByAssignee({ page, pageSize, order, ascDesc, search, name, userName, code, referenceNum, workRequestName, workRequestReferenceNum , status, progress, type, verifiedBy, submittedBy, from, to, isLocked, isChecked }, callback, errorCallback) {
  let query = `?page=${page ? page : 1}&perPage=${pageSize ? pageSize : 20}`;

  if (order) query += `&order=${order}`;
  if (ascDesc) query += `&ascDesc=${ascDesc}`;
  if (search) query += `&search=${search}`;
  if (name) query += `&name=${name}`;
  if (code) query += `&code=${code}`;
  if (referenceNum) query += `&referenceNum=${referenceNum}`;
  if (workRequestName) query += `&workRequestName=${workRequestName}`;
  if (workRequestReferenceNum) query += `&workRequestReferenceNum=${workRequestReferenceNum}`;
  if (progress) query += `&progress=${progress}`;
  if (status) query += `&status=${status}`;
  if (type) query += `&type=${type}`;
  if (submittedBy) query += `&submittedBy=${submittedBy}`;
  if (verifiedBy) query += `&verifiedBy=${verifiedBy}`;
  if (from) query += `&from=${from}`;
  if (to) query += `&to=${to}`;
  if (userName) query += `&userName=${userName}`;
  if (isLocked) query += `&isLocked=${isLocked}`;
  if (isChecked) query += `&isChecked=${isChecked}`;

  const request = axios.get(`${endpoint}${query}`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: WorkItemActionTypes.FIND_BY_ASSIGNEE,
    payload : request
  };
}



// WEBPACK FOOTER //
// ./src/actions/workitem_assignee.action.js